/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesconfirmtitle2Inputs */

const en_filesconfirmtitle2 = /** @type {(inputs: Filesconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm this category`)
};

const pt_filesconfirmtitle2 = /** @type {(inputs: Filesconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar esta categoria`)
};

/**
* | output |
* | --- |
* | "Confirm this category" |
*
* @param {Filesconfirmtitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesconfirmtitle2 = /** @type {((inputs?: Filesconfirmtitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesconfirmtitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesconfirmtitle2(inputs)
	return pt_filesconfirmtitle2(inputs)
});
export { filesconfirmtitle2 as "filesConfirmTitle" }